"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isEligibleForRanking = isEligibleForRanking;
function isEligibleForRanking(input) {
    return input.normedMinutes >= input.rankingMinNormedMinutes;
}
//# sourceMappingURL=ranking-eligibility.js.map